import { createChangeInputEvent } from "../../utils-p6tjltbX.js";
import { mergeRefs } from "../utils/mergeRefs.js";
import { ArrowBigUpDash, Eye, EyeOff, X } from "../../icons-ZIeZXXS7.js";
import { InputGroup } from "../../InputGroup-Dm014ruw.js";
import { useControllableState } from "../../useControllableState-CUYXMsfz.js";
import { useRef, useState } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/blocks/PasswordInput/PasswordInput.tsx
const PasswordInput = ({ ref, state, variant, focusVariant, sizing, className, value: valueProp, defaultValue, onValueChange, onValueBlur, onChange, onBlur, onKeyDown, onKeyUp, onMouseDown, allowClear = false, allowPasswordToggle = false, passwordToggleLabel, autoComplete = "new-password", defaultPasswordVisibility = false, disabled, readOnly, ...restInputProps }) => {
	const inputRef = useRef(null);
	const [value, setValue] = useControllableState({
		prop: valueProp === null ? "" : valueProp,
		defaultProp: defaultValue ?? "",
		onChange: onValueChange
	});
	const [capsLock, setCapsLock] = useState(false);
	const [isPasswordVisible, setIsPasswordVisible] = useState(defaultPasswordVisibility);
	const canClear = allowClear && !!value && !disabled && !readOnly;
	const handleChange = (event) => {
		setValue(event.target.value);
		onChange?.(event);
	};
	const handleBlur = (event) => {
		if (capsLock) setCapsLock(false);
		onValueBlur?.(event.target.value);
		onBlur?.(event);
	};
	const handleKeyDown = (event) => {
		const isOn = event.getModifierState("CapsLock");
		if (isOn !== capsLock) setCapsLock(isOn);
		onKeyDown?.(event);
	};
	const handleKeyUp = (event) => {
		const isOn = event.getModifierState("CapsLock");
		if (isOn !== capsLock) setCapsLock(isOn);
		onKeyUp?.(event);
	};
	const handleMouseDown = (event) => {
		const isOn = event.getModifierState("CapsLock");
		if (isOn !== capsLock) setCapsLock(isOn);
		onMouseDown?.(event);
	};
	const handleClear = () => {
		if (!inputRef.current) return;
		inputRef.current.value = "";
		setValue("");
		onChange?.(createChangeInputEvent(inputRef.current));
	};
	const handleTogglePasswordVisibility = () => {
		setIsPasswordVisible((prev) => !prev);
	};
	return /* @__PURE__ */ jsxs(InputGroup, {
		state,
		variant,
		sizing,
		focusVariant,
		className,
		children: [/* @__PURE__ */ jsx(InputGroup.Input, {
			...restInputProps,
			ref: mergeRefs(ref ?? null, inputRef),
			type: isPasswordVisible ? "text" : "password",
			autoComplete,
			value,
			onChange: handleChange,
			onBlur: handleBlur,
			onKeyDown: handleKeyDown,
			onKeyUp: handleKeyUp,
			onMouseDown: handleMouseDown,
			disabled,
			readOnly
		}), (capsLock || canClear || allowPasswordToggle) && /* @__PURE__ */ jsxs(InputGroup.Addon, {
			align: "inline-end",
			children: [
				capsLock && /* @__PURE__ */ jsx(ArrowBigUpDash, {
					className: "tw:size-4 tw:text-primary",
					children: /* @__PURE__ */ jsx("title", { children: "Caps Lock is on" })
				}),
				canClear && /* @__PURE__ */ jsx(InputGroup.Button, {
					"aria-label": "Clear password",
					onMouseDown: (event) => event.preventDefault(),
					onClick: handleClear,
					children: /* @__PURE__ */ jsx(X, { className: "tw:size-4" })
				}),
				allowPasswordToggle && /* @__PURE__ */ jsx(InputGroup.Button, {
					"aria-label": `${isPasswordVisible ? "Hide password" : "Show password"}${passwordToggleLabel ? `: ${passwordToggleLabel}` : ""}`,
					onMouseDown: (event) => event.preventDefault(),
					onClick: handleTogglePasswordVisibility,
					children: isPasswordVisible ? /* @__PURE__ */ jsx(EyeOff, { className: "tw:size-4" }) : /* @__PURE__ */ jsx(Eye, { className: "tw:size-4" })
				})
			]
		})]
	});
};
//#endregion
export { PasswordInput };

//# sourceMappingURL=PasswordInput.js.map